import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import HentaiInformation from '@/components/disposable/HentaiInformation.vue';
import { Hentai, HentaiStatus } from '@/model/hentai';
import { getHentai, updateHentai } from '@/repository/hentai';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateHentaiView',
  setup(__props) {

const hentaiUUID = useRoute().params.hentaiUUID as string;
const store = useStore();
const { push } = useRouter();
const isLoading = ref(true);

const hentai = ref<Hentai>({
	coverImageURL: '',
	title: '',
	studio: '',
	episode: {},
	description: '',
	categories: [],
	note: '',
	status: HentaiStatus.OnGoing,
	link: ''
});

onMounted(async () => {
	try {
		const res = await getHentai(hentaiUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('hentai uuid is not found');
		}
		hentai.value = res.data;
	} catch (error) {
		push(`/hentai`);
	} finally {
		isLoading.value = false;
	}
});

async function submit(hentai: Hentai, isRedirect: boolean) {
	try {
		isLoading.value = true;
		const res = await updateHentai(hentai);
		if (res.data) {
			isLoading.value = false;
			store.dispatch('alert', { type: 'success', message: `Create new hentai successfully!` });
			if (isRedirect) {
				push(`/hentai/${hentaiUUID}`);
			}
			return;
		}
		throw Error('Something went wrong, please try again!');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HentaiInformation, {
    hentaiStatuses: [_unref(HentaiStatus).OnGoing, _unref(HentaiStatus).Completed],
    isLoading: isLoading.value,
    hentai: hentai.value,
    onSubmit: submit
  }, null, 8, ["hentaiStatuses", "isLoading", "hentai"]))
}
}

})